import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-sn.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-sn.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationDetailsSnConstants } from "./view-application-details-sn.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute } from "@angular/router";
import { SaShortDatePipe } from "../../../../../shared/pipes/sa-short-date/sa-short-date.pipe";
import { UserInformationService } from "../../../../../shared/services/user/user-information.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
let ViewApplicationDetailsSnComponent = class ViewApplicationDetailsSnComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    saShortDatePipe;
    userInformationService;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    applicationDetailsFormGroupName = ViewApplicationDetailsSnConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = ViewApplicationDetailsSnConstants.DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberFormControlName = ViewApplicationDetailsSnConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsSnConstants.DESCRIPTION_FORM_LABEL;
    referenceNumberLabel = ViewApplicationDetailsSnConstants.REFERENCE_NUMBER_FORM_LABEL;
    applicationTypeLabel = ViewApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    validationMessages = ViewApplicationDetailsSnConstants.VALIDATION_MESSAGES;
    applicationTypeLookUpName = ViewApplicationDetailsSnConstants.APPLICATION_TYPE_LOOKOUT_NAME;
    application;
    getLookupsObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, route, saShortDatePipe, userInformationService, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.saShortDatePipe = saShortDatePipe;
        this.userInformationService = userInformationService;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        if (this.aflaModuleStrategyService.lookups.has(this.applicationTypeLookUpName)) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get(this.applicationTypeLookUpName);
            this.getApplication();
        }
        else {
            this.getLookups();
        }
    }
    handleRouteChange() {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID} and deleted eq false`,
        };
        this.viewApplicationService.getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsSnConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberFormControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.type);
            this.detailsForm.get(this.applicationTypeFormControlName).disable();
            this.detailsForm.get(this.referenceNumberFormControlName).disable();
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.changeDetectorRefs.detectChanges();
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.viewApplicationService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsSnConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypes.push(lookUpContent);
            }
        });
        this.aflaModuleStrategyService.lookups.set(this.applicationTypeLookUpName, this.applicationTypes);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: SaShortDatePipe },
        { type: UserInformationService },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsSnComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-sn",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsSnComponent);
export { ViewApplicationDetailsSnComponent };
